var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1218,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.2 688.664c83.192-48.144 139.2-138.032 139.2-241.064h-139.2v241.064z",
    fill: "#FFFFFF",
    "p-id": 1220
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M720.8 631.644c43.304-49.052 69.6-113.46 69.6-184.044h-69.6v184.044z",
    fill: "#D4E7F8",
    "p-id": 1221
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372.8 688.664V447.6H233.6c0 103.028 56.008 192.92 139.2 241.064zM372.8 447.6v241.064A277 277 0 0 0 512 726v-278.4H372.8zM651.2 447.6H512v278.4a277.04 277.04 0 0 0 139.2-37.336V447.6z",
    fill: "#FFFFFF",
    "p-id": 1222
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 613.968c-86.48 0-172.964-13.192-257.044-39.58a12 12 0 1 1 7.188-22.9c163.452 51.296 336.256 51.296 499.712 0a12.004 12.004 0 0 1 7.188 22.9c-84.08 26.384-170.564 39.58-257.044 39.58z",
    fill: "#504774",
    "p-id": 1223
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M372.8 700.664a11.996 11.996 0 0 1-6.012-1.612C277.236 647.224 221.6 550.872 221.6 447.6a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12v241.064a12 12 0 0 1-12 12zM245.876 459.6c3.784 83.064 46.656 160.056 114.924 207.264V459.6H245.876z",
    fill: "#504774",
    "p-id": 1224
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 738a290.248 290.248 0 0 1-145.212-38.952 12 12 0 0 1-5.988-10.388V447.6a12 12 0 0 1 12-12H512a12 12 0 0 1 12 12v278.4a12 12 0 0 1-12 12z m-127.2-56.36a266.264 266.264 0 0 0 115.2 32.088V459.6H384.8v222.04z",
    fill: "#504774",
    "p-id": 1225
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M512 738a12 12 0 0 1-12-12v-278.4a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12v241.064a12 12 0 0 1-5.988 10.388A290.284 290.284 0 0 1 512 738z m12-278.4v254.128a266.32 266.32 0 0 0 115.2-32.088V459.6H524z",
    fill: "#504774",
    "p-id": 1226
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M651.2 700.664a12 12 0 0 1-12-12V447.6a12 12 0 0 1 12-12h139.2a12 12 0 0 1 12 12c0 103.272-55.632 199.624-145.188 251.448a12.012 12.012 0 0 1-6.012 1.616z m12-241.064v207.264c68.268-47.208 111.14-124.2 114.924-207.264H663.2zM170.992 501.36a12 12 0 0 1-11.88-10.412l-0.076-0.556c-6.324-46.384 11.484-91.876 47.648-121.66a12 12 0 0 1 16.892 1.636 12 12 0 0 1-1.632 16.892c-29.696 24.456-44.32 61.808-39.12 99.92l0.08 0.584a12.004 12.004 0 0 1-11.912 13.596zM853.008 501.36a12 12 0 0 1-11.908-13.596l0.076-0.556c5.204-38.14-9.42-75.496-39.116-99.948a12 12 0 1 1 15.26-18.528c36.164 29.784 53.972 75.276 47.644 121.688l-0.072 0.524a12.012 12.012 0 0 1-11.884 10.416z",
    fill: "#504774",
    "p-id": 1227
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.584cae829e443e5db8654de9d0551b25.svg";
export { ForwardRef as ReactComponent };